import { gql } from 'apollo-angular';

const DEAL_TERMS_FRAGMENT = gql`
  fragment DealTermsFields on DealTerm {
    id
    project_id
    credit_delivery_end
    year_15_end
    residual_split
    non_profit_rofr
    non_profit_start
    non_profit_end
    year_11_ilp_put_option
    year_11_ilp_start
    year_11_ilp_end
    year_15_ilp_put_option
    year_15_ilp_start
    year_15_ilp_end
    year_11_gp_call_option
    year_11_gp_start_COMPUTE
    year_11_gp_end_COMPUTE
    year_15_gp_call_option
    year_15_gp_start_COMPUTE
    year_15_gp_end_COMPUTE
    year_11_gp_call_months
    year_15_gp_call_months
    has_exit_taxes_waterfall
    has_exit_taxes_gp_call
    prep_fee_type
    gp_prep_fee_pct
  }
`;
export type UpdateDealTermInput = {
  credit_delivery_end: string | null;
  year_15_end: string | null;
  residual_split: number | null;
  non_profit_rofr: boolean | null;
  non_profit_start: string | null;
  non_profit_end: string | null;
  year_11_ilp_put_option: string | null;
  year_11_ilp_start: string | null;
  year_11_ilp_end: string | null;
  year_15_ilp_put_option: string | null;
  year_15_ilp_start: string | null;
  year_15_ilp_end: string | null;
  year_11_gp_call_option: string | null;
  year_15_gp_call_option: string | null;
  year_11_gp_call_months: number|null;
  year_15_gp_call_months: number|null;
  has_exit_taxes_waterfall: boolean|null;
  has_exit_taxes_gp_call: boolean|null;
  gp_prep_fee_pct: number|null;
  prep_fee_type: string|null;
};
const GET_DEAL_WITH_TERMS = gql`
  query getProjectWithTerms($id: ID!) {
    project(id: $id) {
      id
      name
      dealTerm {
        ...DealTermsFields
      }
    }
    me {
      permissionsForResource(resourceType: DEALTERM) {
        _read
        _create
        _edit
        _delete
      }
      user_profile {
        user {
          username
        }
      }
    }
  }
  ${DEAL_TERMS_FRAGMENT}
`;

const INIT_DEAL_TERMS = gql`
  mutation initializeDealTerms($project_id: ID!) {
    createDealTerm(project_id: $project_id) {
      ...DealTermsFields
    }
  }
  ${DEAL_TERMS_FRAGMENT}
`;
const SAVE_DEAL_TERMS = gql`
  mutation updateDealTerms($id: ID!, $input: UpdateDealTermInput) {
    updateDealTerm(id: $id, input: $input) {
      ...DealTermsFields
    }
  }
  ${DEAL_TERMS_FRAGMENT}
`;

export { GET_DEAL_WITH_TERMS, INIT_DEAL_TERMS, SAVE_DEAL_TERMS };
